import * as actionTypes from "./actionTypes";

const initialPagination = { optional: 0 };

const initialState = {
  fetchAuditLogsReportLoading: true,
  auditlogsReportData: [],
  pagination: initialPagination,
  auditlogReportErrorMessage: "",
  downloadAuditLogsReportLoading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_AUDIT_LOGS_REPORT:
      return {
        ...state,
        fetchAuditLogsReportLoading: true,
        auditlogReportErrorMessage: "",
      };

    case actionTypes.FETCH_AUDIT_LOGS_REPORT_SUCCESS: {
      return {
        ...state,
        fetchAuditLogsReportLoading: false,
        auditlogsReportData: action.payload.data,
        pagination: action.payload.meta || state.pagination,
      };
    }

    case actionTypes.FETCH_AUDIT_LOGS_REPORT_FAILED:
      return {
        ...state,
        fetchAuditLogsReportLoading: false,
        auditlogsReportData: [],
        pagination: initialPagination,
        auditlogReportErrorMessage: action.payload,
      };
    case actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT:
      return {
        ...state,
        downloadAuditLogsReportLoading: true,
        auditlogReportErrorMessage: "",
      };

    case actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT_SUCCESS:
      return {
        ...state,
        downloadAuditLogsReportLoading: false,
      };

    case actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT_FAILED:
      return {
        ...state,
        downloadAuditLogsReportLoading: false,
        auditlogReportErrorMessage: action.payload,
      };

    default:
      return state;
  }
};
